import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getPublishedSiteDetailsRequest = {
    fieldMask: 'google.protobuf.FieldMask',
};
var _getPublishedSiteDetailsResponse = {
    publishedSiteDetails: '_publishedSiteDetails',
};
var _publishedSiteDetails = { lastUpdatedAt: 'google.protobuf.Timestamp' };
var _resolveProtectedPagesJsonFilenameRequest = {};
var _resolveProtectedPagesJsonFilenameResponse = {};
function resolveComWixpressHtmlInfoRpcPublishedSiteDetailsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-public-html-info-webapp',
                destPath: '',
            },
        ],
        'site-pages._base_domain_': [
            {
                srcPath: '/wix-public-html-info-webapp/api/resolve_protected_page_urls',
                destPath: '/api/resolve_protected_page_urls',
            },
            {
                srcPath: '/_api/wix-public-html-info-webapp/resolve_protected_page_urls',
                destPath: '/api/resolve_protected_page_urls',
            },
            {
                srcPath: '/_api/wix-public-html-info-webapp/published-site-details',
                destPath: '/v1/published-site-details',
            },
            {
                srcPath: '/_api/wix-public-html-info-webapp/resolve-protected-pages',
                destPath: '/v1/resolve-protected-pages',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-public-html-info-webapp/v1/published-site-details',
                destPath: '/v1/published-site-details',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-public-html-info-webapp/v1/published-site-details',
                destPath: '/v1/published-site-details',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-public-html-info-webapp/v1/published-site-details',
                destPath: '/v1/published-site-details',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-public-html-info-webapp/resolve-protected-pages',
                destPath: '/v1/resolve-protected-pages',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns the details of the published site. */
export function getPublishedSiteDetails(payload) {
    var _a = serializer(_getPublishedSiteDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPublishedSiteDetailsResponse, {
        _publishedSiteDetails: _publishedSiteDetails,
    }).fromJSON;
    function __getPublishedSiteDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.document_management.public_editor_info.v1.published_site_details',
            method: 'GET',
            methodFqn: 'com.wixpress.html.info.rpc.PublishedSiteDetailsService.GetPublishedSiteDetails',
            url: resolveComWixpressHtmlInfoRpcPublishedSiteDetailsServiceUrl({
                protoPath: '/v1/published-site-details',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPublishedSiteDetails.fromReq = fromReq;
    __getPublishedSiteDetails.__isAmbassador = true;
    return __getPublishedSiteDetails;
}
/** Returns the resolved json files name for the given page id and password. */
export function resolveProtectedPagesJsonFilename(payload) {
    var _a = serializer(_resolveProtectedPagesJsonFilenameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveProtectedPagesJsonFilenameResponse, {}).fromJSON;
    function __resolveProtectedPagesJsonFilename(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.document_management.public_editor_info.v1.published_site_details',
            method: 'POST',
            methodFqn: 'com.wixpress.html.info.rpc.PublishedSiteDetailsService.ResolveProtectedPagesJsonFilename',
            url: resolveComWixpressHtmlInfoRpcPublishedSiteDetailsServiceUrl({
                protoPath: '/v1/resolve-protected-pages',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveProtectedPagesJsonFilename.fromReq = fromReq;
    __resolveProtectedPagesJsonFilename.__isAmbassador = true;
    return __resolveProtectedPagesJsonFilename;
}
//# sourceMappingURL=http.impl.js.map